import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  NoVehiclesWrapper,
  NoVehiclesHeader,
  NoVehiclesText,
  CTAWrapper,
  Button,
  TextP,
  IconWrapper,
} from './NoVehicleFound.style';
import LocationIcon from '../../assets/icons/LocationIcon';
import { COLORS } from '../../styles/variables';
import FilterIcon from '../../assets/icons/FilterIcon';
import { clearAllFilters } from '../../redux/filtersReducer';

interface NoVehiclesFoundTypes {
  onLocationSearchOpen: () => void;
  noCtas?: boolean;
}

const NoVehiclesFound: React.FC<NoVehiclesFoundTypes> = ({ onLocationSearchOpen, noCtas }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <NoVehiclesWrapper data-testid="no-vehucle-found">
      <NoVehiclesHeader>{t('vlp.vehicleResults.notFoundContent.title')}</NoVehiclesHeader>
      <NoVehiclesText>
        <TextP>{t('vlp.vehicleResults.notFoundContent.text1')}</TextP>
        <TextP>{t('vlp.vehicleResults.notFoundContent.text2')}</TextP>
      </NoVehiclesText>
      {!noCtas && (
        <CTAWrapper>
          <Button onClick={() => dispatch(clearAllFilters())} data-cy="reset-filters-non-found">
            <IconWrapper>
              <FilterIcon color={COLORS.black} size={24} />
            </IconWrapper>
            {t('vlp.vehicleResults.notFoundContent.resetFilters')}
          </Button>
          <Button onClick={onLocationSearchOpen} data-cy="location-search-open-non-found">
            <IconWrapper>
              <LocationIcon color={COLORS.black} />
            </IconWrapper>
            {t('vlp.vehicleResults.notFoundContent.adjustLocation')}
          </Button>
        </CTAWrapper>
      )}
    </NoVehiclesWrapper>
  );
};

export default NoVehiclesFound;
